import { 
	SET_BOARD,
	SET_BOARD_STRUCTURE,
	UPDATE_BOARD,
	UPDATE_BOARD_DATASERIES_LIST_ASSOCIATION,
	UPDATE_BOARD_FULL_STRUCTURE,
	UPDATE_BOARD_NAME,
	UPDATE_BOARD_TIME_AGGREGATION,
	UPDATE_BOARD_CONTAINER_TITLE,
	UPDATE_BOARD_MOVE_ZONES,
	CLEAR_BOARD_CONTEXT,
	UPDATE_BOARD_FULL_STRUCTURE_NEW_TEMPORAL,
	UPDATE_BOARD_FULL_STRUCTURE_CONTAINERS,
	SET_REPORT_COMPONENTS_TYPETEXT,
	UPDATE_BOARD_TEMPLATE_TYPE
} from "./actions/KPI/actions";

const initialState = {
	_board: {
		boardCode: 0,
		creationDate: null,
		displayCurrency: false,
		id :0,
		name: null,
		numberFix: null,
		owner: null,
		timeAggregationId: null,
		boardTypeId: null,
		boardTypeReadOnly: null,
	},

	_boardStructure: {
		boardCode: 0,
		creationDate: null,
		displayCurrency: false,
		id :0,
		l_structure: [],
		name: null,
		numberFix: null,
		owner: null,
		timeAggregationId: null
	},

	_baseStructure: {
		boardCode: 0,
		creationDate: null,
		displayCurrency: false,
		id :0,
		l_structure: [],
		name: null,
		numberFix: null,
		owner: null,
		timeAggregationId: null
	},

	_boardStructureNew: [],
	_boardStructureNew_Flag: true,
	_moveZones: false,


	_boardReportComponents: {
		componentInfoTypeText: null,
		componentInfoComment: null,
		componentInfoCustomText: null,
		componentInfoFinancial: null,
	}
};

const boardReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BOARD:
			return {
				...state,
				_board: action.payload.object
			};
		case SET_BOARD_STRUCTURE:
			return {
				...state,
				_boardStructure: action.payload.object,
				_baseStructure: action.payload.object
			};
		case UPDATE_BOARD_TIME_AGGREGATION:
			return {
				...state,
				_board: {
					...state._board,
					timeAggregationId: action.payload.object
				}
			};
		case UPDATE_BOARD_TEMPLATE_TYPE:
			return {
				...state,
				_board: {
					...state._board,
					boardTypeId: action.payload.object
				}
			};
		case UPDATE_BOARD_NAME:
			return {
				...state,
				_board: {
					...state._board,
					name: action.payload.object
				}
			};
		case UPDATE_BOARD:
			return {
				...state,
				_board: {
					...state._board,
					id : action.payload.object.id,
					boardCode : action.payload.object.boardCode,
					name : action.payload.object.name,
					owner : action.payload.object.owner,
					timeAggregationId : action.payload.object.timeAggregationId,
					displayCurrency : action.payload.object.displayCurrency,
					numberFix : action.payload.object.numberFix,
					creationDate : action.payload.object.creationDate,
					statusId: action.payload.object.statusId
				}
			};
		case UPDATE_BOARD_FULL_STRUCTURE:
			return {
				...state,
				_boardStructure: {
					...state._boardStructure,
					l_structure: action.payload.object
				}
			};
		case UPDATE_BOARD_FULL_STRUCTURE_CONTAINERS:
			return {
				...state,
				_boardStructure: {
					...state._boardStructure,
					l_structure: action.payload.object
				}
			};
		case UPDATE_BOARD_FULL_STRUCTURE_NEW_TEMPORAL:
			return {
				...state,
				_boardStructureNew: action.payload.object,
				_boardStructureNew_Flag: action.payload.flag
			};
			
		case UPDATE_BOARD_DATASERIES_LIST_ASSOCIATION:
			const { containerId, objectList } = action.payload;
			const originalList = state._baseStructure.l_structure[0].l_container.find(x => x.id === containerId).l_components;

			//Todas las dataseries de todos los contenedores
			const allDataseries = state._baseStructure.l_structure[0].l_container.flatMap(container =>
				container.l_components.map(component => component)
			);

			//Quitar las dataseries que se manipularon de sus origenes.
			state._baseStructure.l_structure[0].l_container = state._baseStructure.l_structure[0].l_container.map(container => ({
				...container,
				l_components: container.l_components.filter(component =>
				  	!objectList.some(aux => aux.dataserieId === component.dataserieId)
				)
			}));

			//Obtener las dataseries que se manipularon de la estructura para tener los elementos originales (Por si algun cambio sufieron volatilmente)
			const updatedList = allDataseries.filter(obj => objectList.some(o => o.dataserieId === obj.dataserieId));

			//Obtener el contenedor donde se deben agregar las dataseries manipuladas.
			const container = state._baseStructure.l_structure[0].l_container.find(container => container.id === containerId);
			if (container) {
				//Agregar las dataseries al nuevo contenedor.
				container.l_components = container.l_components.concat(updatedList);
			}
		
			return {
				...state,
				_boardStructure: {
					...state._boardStructure,
					l_structure: state._baseStructure.l_structure
				}
			};
		case UPDATE_BOARD_CONTAINER_TITLE:
			state._boardStructure.l_structure.forEach(structure => {
				structure.l_container.forEach(container => {
					if (container.id === action.payload.containerId) {
						container.title = action.payload.title
					}
				});
			});

			return {
				...state,
				_boardStructure: {
					...state._boardStructure,
					l_structure: state._boardStructure.l_structure
				}
			};
		case UPDATE_BOARD_MOVE_ZONES:
			return {
				...state,
				_moveZones: action.payload
			};
		case CLEAR_BOARD_CONTEXT:
			return {
				_boardStructure: {
					boardCode: 0,
					creationDate: null,
					displayCurrency: false,
					id :0,
					l_structure: [],
					name: null,
					numberFix: null,
					owner: null,
					timeAggregationId: null
				},
				_baseStructure: {
					boardCode: 0,
					creationDate: null,
					displayCurrency: false,
					id :0,
					l_structure: [],
					name: null,
					numberFix: null,
					owner: null,
					timeAggregationId: null
				},
				_moveZones: false
			};
		case SET_REPORT_COMPONENTS_TYPETEXT:
			return {
				...state,
				_boardReportComponents: {
					...state,
					componentInfoTypeText: action.payload.infoTypeText,
					componentInfoComment: action.payload.infoComment,
					componentInfoCustomText: action.payload.infoCustomText,
					componentInfoFinancial: action.payload.infoFinancial,
				}
			};
		default:
			return state;
	}
};

export default boardReducer;